<ng-container *ngIf="!isStaticContent && !loading">
    <BTA-home-header></BTA-home-header>

    <section class="hero-section">
        <div class="hero-plate">
            <div class="hero-art">
                <img class="hero-sky" src="assets/images/home/hero-sky.jpg" alt="" aria-hidden="true">
                <img class="hero-plane" src="assets/images/home/hero-plane.png" alt="" aria-hidden="true">
                <span class="hero-fade" aria-hidden="true"></span>
            </div>

            <div class="hero-copy">
                <span class="hero-eyebrow">B2B Flight Booking Platform</span>

                <h1 class="hero-title">
                    <span class="hero-title__lead">The Smarter Platform for</span>
                    <span class="hero-title__main">Global Flight Booking</span>
                </h1>

                <p class="hero-tagline">One platform. 700+ airlines. Unmatched B2B fares</p>
            </div>

            <div class="airline-strip">
                <div class="airline-track">
                    <img *ngFor="let airline of airlines" class="airline-logo" [src]="airline.src"
                        [alt]="airline.name">
                    <!-- Duplicate pass so the loop is seamless; hidden from AT so
                         the airline names are not announced twice. -->
                    <img *ngFor="let airline of airlines" class="airline-logo" [src]="airline.src" alt=""
                        aria-hidden="true">
                </div>
            </div>
        </div>

        <div class="hero-login">
            <div class="login-card">
                <app-login></app-login>
            </div>
        </div>
    </section>
</ng-container>

<ng-container *ngIf="isStaticContent && !loading && htmlContent">
    <app-static-page [htmlContent]="htmlContent"></app-static-page>
</ng-container>
